module.exports = __webpack_public_path__ + "img/body-model-torso.219eecfa.svg";